
































































/* eslint-disable @typescript-eslint/no-explicit-any */
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import G_140_HaisoIrai_ChildHeader_Table from '@/components/G_kaigai/G_140_HaisoIrai_ChildHeader_Table.vue';
import {
  Flg,
  UmuFlg,
  MukoFlg,
  OutStatus,
} from '@/constants/constants';
import { BUTTON } from '@/constants/label';
import {
  add,
  formatNumber,
} from '@/utils/utils';
import Vue from 'vue';
import { mapGetters } from 'vuex';

/* eslint-disable @typescript-eslint/no-explicit-any */
export default Vue.extend<any, any, any, any>({
  name: 'G_140_HaisoIrai_ChildHeader',
  components: {
    G_140_HaisoIrai_ChildHeader_Table,
    CtrlNormalBtn,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    childItem: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    BUTTON,
    Flg,
    UmuFlg,
    MukoFlg,
    detailData: [],
    messageShow: false,
    messageId: '',
    messageTextParam: [],
    cMessageShow1: false,
    cMessageId1: '',
    cMessageTextParam1: [],
    messageConfirmSubmit: false,
    isReload: false,
    formKey: 0,
    childDetailItem: null,
  }),
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
    }),
    suryoTotal() {
      const total = this.detailData.reduce(
        (total: number, item: any) =>(total = add(item.haisoIraiSuryo, total)),
        0
      );
      return formatNumber({ value: total, minimumFractionDigits: 0 });
    },
    hasuTotal() {
      const total = this.detailData.reduce(
        (total: number, item: any) =>(total = add(item.haisoIraiHasu, total)),
        0
      );
      return formatNumber({ value: total, minimumFractionDigits: 0 });
    },
    juryoTotal() {
      const total = this.detailData.reduce(
        (total: number, item: any) =>(total = add(item.haisoIraiJuryo, total)),
        0
      );
      return formatNumber({ value: total, minimumFractionDigits: 2 });
    },
  },
  methods: {
    hide(reload = true) {
      this.$emit('update:show', false);
      this.$emit('hide', reload);
    },
    async getDetail() {
      const {
        haisoIraiJigyoshoCd,
        haisoIraiEntryYmd,
        haisoIraiNo,
      } = this.childItem;

      const params = {
        haisoIraiJigyoshoCd,
        haisoIraiEntryYmd,
        haisoIraiNo,
      };

      const response = await this.$store.dispatch(
        'g140/getDetail',
        params
      );
      if (
        response &&
        response.status == 200 &&
        response.data &&
        response.data.error &&
        response.data.error.outStatus &&
        response.data.error.outStatus != OutStatus.NORMAL
      ) {
        // 自画面を閉じて、再検索
        this.wMessageId = response.data.error.messageID;
        this.wMessageTextParam = response.data.error.messageArgs;
        this.wMessage = true;
        return;
      }

      this.detailData = response.data.responseData ? response.data.responseData : [];

    },
  },
  async created() {
    await this.getDetail(this.item);
  },
  mounted() {    
    setTimeout(() => {
      this.mounted = true;
    }, 3100);
  },
});
